<template>
  <div id="hrms62e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :unLoadBool="true"
            :receivedStore="receivedHrms62eIndex"
            searchBoxAlias="request-subrogate"
            :maxRowspan="maxRowspan.index"
            :addEvent="addEvent"
            :editEvent="editEvent"
            :cancelEvent="cancelEvent" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :detail="detail"
            :currentDtereq="currentDtereq"
            :descCodempid="app.currentUser.username[app.nowLang]"
            :currentNumseq="detail.seqno"
            :currentCodempid="codempid"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :postHrms62eSave="postHrms62eSave"
            :indexSelected="indexSelected"
            :arrCodleave="dropdowns.codleave"
            :entitlement="entitleFlagleave.entitlement"
            :enableFlagLeave="entitleFlagleave.enableflagleave"
            :worktime="worktime"
            :receivedHrms62eEntitlement="receivedHrms62eEntitlement"
            :receivedHrms62eWorktime="receivedHrms62eWorktime"
            :descCodapp="dash.descCodapp"
            :eventBtn="eventBtn"
            :receivedHrms62eCreate="receivedHrms62eCreate"
            :descCodempidQuery="descCodempidQuery"
            :searchIndex="searchIndex"
            :searchDetail="searchDetail"
            :popup="popup"
            :receivedHrms62ePopup="receivedHrms62ePopup"
            :receivedHrms62eIndex="receivedHrms62eIndex"
            :receivedHrms62eCodleave="receivedHrms62eCodleave"
            :detailDisp="detailDisp" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms62e/mutation-types'
import detail from 'components/hrms62e/detail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import * as lovCodcompTypes from 'store/modules/hrmsLovCodcomp/mutation-types'

export default {
  name: 'hrms62e',
  data () {
    return {
      searchIndex: {
        dtereqst: '01/' + moment().format('MM/YYYY'),
        dtereqen: moment().format('DD/MM/YYYY')
      },
      app: this.$parent.$parent.$parent,
      dash: this.$parent.$parent.$parent.$children[0],
      currentDtereq: moment().format('DD/MM/YYYY'),
      eventBtn: '',
      searchDetail: {
        dtework: moment().format('DD/MM/YYYY'),
        seqno: '',
        codempid_query: this.$parent.$parent.$parent.currentUser.p_codempid
      }
    }
  },
  created () {
    this.receivedHrms62eColumnsLabels()
    this.receivedHrms62eDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS62E_INDEX_DISP,
      detailDisp: types.GET_HRMS62E_DETAIL_DISP,
      maxRowspan: types.GET_HRMS62E_MAX_ROWSPAN,
      columns: types.GET_HRMS62E_COLUMNS,
      labels: types.GET_HRMS62E_LABELS,
      index: types.GET_HRMS62E_INDEX,
      indexSelected: types.GET_HRMS62E_INDEX_SELECTED,
      detail: types.GET_HRMS62E_DETAIL,
      dropdowns: types.GET_HRMS62E_DROPDOWNS,
      entitleFlagleave: types.GET_HRMS62E_ENTITLE_FLAG_LEAVE,
      worktime: types.GET_HRMS62E_WORKTIME,
      lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC,
      lovCodcompCurrentDesc: lovCodcompTypes.GET_LOV_CODCOMP_CURRENT_DESC,
      popup: types.GET_HRMS62E_POPUP
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'add':
          this.searchDetail.dtework = moment().format('DD/MM/YYYY')
          this.searchDetail.seqno = ''
          this.searchDetail.codempid_query = this.codempid
          this.eventBtn = 'add'
          this.descCodempidQuery = this.lovCurrentDesc('codempid', this.searchDetail.codempid_query)
          this.receivedHrms62eCreate(this.searchDetail)
          this.currentDtereq = moment().format('DD/MM/YYYY')
          this.toggle('detail')
          break
        case 'edit':
          if (this.indexSelected.seqno) {
            if (this.indexSelected.staappr === 'A' || this.indexSelected.staappr === 'Y' || this.indexSelected.staappr === 'N') {
              swal({
                title: constLabels('warningTitle'),
                text: constLabels('HR1490'),
                confirmButtonText: constLabels('ok')
              })
            }
            this.currentDtereq = this.indexSelected.dtereq
            this.searchDetail.dtereq = this.indexSelected.dtereq
            this.searchDetail.seqno = this.indexSelected.seqno
            this.searchDetail.codempid_query = this.indexSelected.codempid_query
            this.eventBtn = 'edit'
            this.descCodempidQuery = this.lovCurrentDesc('codempid', this.indexSelected.codempid_query)
            this.receivedHrms62eDetail(this.indexSelected)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    cancelEvent (param) {
      this.setIndexSelected(param)
      if (this.indexSelected.staappr === 'P') {
        let sendParams = {
          codempid: this.indexSelected.codempid_query,
          dtereq: this.indexSelected.dtereq,
          seqno: this.indexSelected.seqno,
          staappr: this.indexSelected.staappr
        }
        this.postHrms62eCancel({ cancelParams: sendParams, searchParams: this.searchIndex })
      } else if (this.indexSelected.staappr === 'C') {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1506'),
          confirmButtonText: constLabels('ok')
        })
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('HR1490'),
          confirmButtonText: constLabels('ok')
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS62E_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS62E_PAGE,
      receivedHrms62eColumnsLabels: types.RECEIVED_HRMS62E_COLUMNS_LABELS,
      receivedHrms62eDropdowns: types.RECEIVED_HRMS62E_DROPDOWNS,
      receivedHrms62eIndex: types.RECEIVED_HRMS62E_INDEX,
      receivedHrms62eCreate: types.RECEIVED_HRMS62E_CREATE,
      receivedHrms62eDetail: types.RECEIVED_HRMS62E_DETAIL,
      postHrms62eSave: types.POST_HRMS62E_SAVE,
      postHrms62eCancel: types.POST_HRMS62E_CANCEL,
      receivedHrms62eEntitlement: types.RECEIVED_HRMS62E_ENTITLE_FLAG_LEAVE,
      receivedHrms62eWorktime: types.RECEIVED_HRMS62E_WORKTIME,
      receivedHrms62ePopup: types.RECEIVED_HRMS62E_POPUP,
      receivedHrms62eCodleave: types.RECEIVED_HRMS62E_CODLEAVE
    })
  },
  components: {
    detail
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?153b42dc